module.exports = __webpack_public_path__ + "static/media/MyriadPro-Bold.b9834d4c.svg";